import _ from 'underscore';
import {
    TOGGLE_AGENDA_FILTER,
    SELECT_AGENDA_FILTER_CAT,
    SET_AGENDA_SESSIONS,
    SET_AGENDA_SESSIONS_MAP,
    IS_AGENDA_LOADING,
    CLIENT_NAVIGATION,
    REMOVE_AGENDA_MARKER,
    ADD_AGENDA_MARKER,
    SET_MARKERS,
    SET_AGENDA_SETTINGS,
    SET_AGENDA_SPEAKERS,
    SET_AGENDA_DAYS,
    SESSION_REGISTRATION_STATUS_CHANGED,
    UPDATE_AGENDA_SESSIONS,
    CHANGE_ACTIVE_TAB,
    CHANGE_VIEW_MODE,
    SET_SLIDER_SESSIONS,
    SET_SESSION_FULL_REGISTRATION,
    SET_SESSION_OVERLAPPING_REGISTRATION,
    SET_AGENDA_SESSION,
    SET_SCROLL_TO_SESSION_BROADCAST,
} from '../constants/ActionTypes';

import {
    SESSIONS_TAB_ALL,
    VIEW_MODE_LIST
} from '../constants/Enums';

const initialState = {
    isLoading: true,
    serverRendered: false,
    settings: null,
    sessions: null,
    speakers: null,
    agendaDays: [],
    markers: null,
    sessionsMap: {},
    filterUI: {
        isFilterOpen: false,
        selectedCategoryId: 0
    },
    isSessionRegistrationEnabled: null,
    activeTab: SESSIONS_TAB_ALL,
    viewMode: VIEW_MODE_LIST,
    scrollToBroadcast: false,
    ringReducer: []
};

const concatArraysByEntityId = (arr1, arr2) => {

    const tmp = _.map(arr1, function(val) {
        const o = _.first(_.filter(arr2, function(a2) {
            return a2.id === val.id;
        }));
        return o ? o : val;
    });

    return _.union(tmp, _.filter(arr2, function(val) {
        return !_.some(tmp, function(a2) {
            a2.id == val.idl;
        });
    }));
};

const addSessions = (oldSessions, newSessions) => {
    const resultSessions = concatArraysByEntityId(oldSessions.sessions, newSessions.sessions);
    return {
        ...oldSessions,
        sessions: resultSessions,
        count: resultSessions.length

    };
};

const removeFavouriteSessionFromMap = (state, marker) => {
    if (marker.markerType === 'addToCal' && state.activeTab !== SESSIONS_TAB_ALL) {
        const sessionsMap = { ...state.sessionsMap};
        delete sessionsMap[marker.entityId];
        return sessionsMap;
    }
    return state.sessionsMap;
};

const updateItemInArray =(array, itemId, updateItemCallback) =>{
    const updatedItems = array.map(item => {
        if (item.id !== itemId) {
            return item;
        }
        const updatedItem = updateItemCallback(item);
        return updatedItem;
    });
    return updatedItems;
};

const AgendaReducer = (state = initialState, action = null) => {
    switch (action.type) {
    case IS_AGENDA_LOADING:
        return {
            ...state,
            isLoading: action.isLoading
        };
    case TOGGLE_AGENDA_FILTER:
        return {
            ...state,
            filterUI: {
                ...state.filterUI,
                isFilterOpen: !state.filterUI.isFilterOpen,
                selectedCategoryId: 0
            }
        };
    case SELECT_AGENDA_FILTER_CAT: {
        const { filterUI: { selectedCategoryId } } = state;
        return {
            ...state,
            filterUI: {
                ...state.filterUI,
                selectedCategoryId:
                    selectedCategoryId === action.payload.id ? 0 : action.payload.id
            }
        };
    }
    case SET_AGENDA_SESSIONS:
        return {
            ...state,
            sessions: {sessions: [], ...action.sessions}
        };
    case UPDATE_AGENDA_SESSIONS:
        return {
            ...state,
            sessions: addSessions(state.sessions, action.sessions)
        };
    case SET_SLIDER_SESSIONS:
        return {
            ...state,
            sessions: addSessions(state.sessions, action.sessions)
        };
    case SET_AGENDA_SESSIONS_MAP:
        return {
            ...state,
            sessionsMap: action.sessionsMap
        };
    case CLIENT_NAVIGATION:
        return {
            ...state,
            serverRendered: false
        };
    case SET_AGENDA_SETTINGS:
        return {
            ...state,
            settings: action.settings,
            viewMode: action.settings.defaultView || state.viewMode
        };
    case SET_AGENDA_SPEAKERS:
        return {
            ...state,
            speakers: action.speakers
        };
    case SET_AGENDA_DAYS:
        return {
            ...state,
            agendaDays: action.agendaDays
        };
    case REMOVE_AGENDA_MARKER:
        return {
            ...state,
            markers: Array.isArray(state.markers) ?
                _.reject(state.markers, action.payload.marker) :
                null,
            sessionsMap: removeFavouriteSessionFromMap(state, action.payload.marker)
        };
    case ADD_AGENDA_MARKER:
        return {
            ...state,
            markers: Array.isArray(state.markers) ?
                [
                    ...state.markers,
                    action.payload.marker
                ] :
                null
        };
    case SET_MARKERS:
        return {
            ...state,
            markers: action.markers
        };
    case SESSION_REGISTRATION_STATUS_CHANGED: {
        return {
            ...state,
            isSessionRegistrationEnabled: action.payload
        };
    }
    case CHANGE_ACTIVE_TAB: {
        return {
            ...state,
            activeTab: action.payload
        };
    }
    case CHANGE_VIEW_MODE: {
        return {
            ...state,
            viewMode: action.payload
        };
    }
    case SET_SESSION_FULL_REGISTRATION: {
        const newSessions = updateItemInArray(state?.sessions?.sessions || [], action.sessionId, (session) => ({
            ...session, ...{
                registrationFull: action.isFullRegistration
            }
        }));
        return {
            ...state,
            sessions: {
                ...state.sessions,
                sessions: newSessions
            }
        };
    }
    case SET_SESSION_OVERLAPPING_REGISTRATION: {
        const newSessions = updateItemInArray(state?.sessions?.sessions || [], action.sessionId, (session) => ({
            ...session, ...{
                overlapping: action.isOverlapping
            }
        }));
        return {
            ...state,
            sessions: {
                ...state.sessions,
                sessions: newSessions
            }
        };
    }
    case SET_SCROLL_TO_SESSION_BROADCAST: {
        return {
            ...state,
            scrollToBroadcast: action.scrollToBroadcast
        };
    }
    default:
        return state;
    }
};

export default AgendaReducer;
